<template>
<div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="Phone" label="手机号码" label-width="100px" class="label-strong">
                <el-input class="popup-input-width-small" @change='checkAllInputs' placeholder="请输入手机号码" v-model="form.Phone"></el-input>
            </el-form-item>
            <el-form-item label="  " label-width="100px">
                <el-button :disabled="smsBtnDisable" v-bind:type="smsBtnClass" @click="smsBtnClick" class="smsBtn">{{smsBtnText}}</el-button>
                <span>收不到验证码</span>
                <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">请确认输入的手机号码为10位<br/>数北美手机号，若还是无法收<br/>到验证码，请联系客服</div>
                        <img src="../assets/question.png">
                    </el-tooltip>
            </el-form-item>
            <el-form-item prop="Code" label="验证码" label-width="100px">
                <el-input class="popup-input-width-small" @change='checkAllInputs' placeholder="请输入收到的验证码" v-model="form.Code"></el-input>
            </el-form-item>
        </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
        <el-row>
            <el-col :span="20" :xs="16" class="footer-left">
                <span v-if="!showError"></span>
                <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
            </el-col>
            <el-col class="footer-right" :span="4" :xs="8">
                <el-button :type="submitBtnClass" @click="save()">确认修改</el-button>
            </el-col>
        </el-row>
    </div>
</div>
</template>

<script>
import {
    getStore,
    setStore
} from "../config/mUtils";
import {
    sendSMS
} from "../service/common.service";
import {
    updatePhone
} from "../service/student.service";
export default {
    data() {
        return {
            showError: false,
            errorMessage: "",
            submitBtnClass: "info",
            smsBtnDisable: true,
            smsBtnClass: "info",
            smsBtnText: " 发送验证码 ",
            isSendSMS: false,
            timer: null,
            form: {
                StudentId: 0,
                Phone: "",
                Code: ""
            },
            rules: {
                Phone: [{
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    {
                        min: 0,
                        max: 10,
                        message: "最大长度在为10个字符",
                        trigger: "blur"
                    }
                ],
                Code: [{
                    required: true,
                    message: "请输入验证码",
                    trigger: "blur"
                }]
            }
        };
    },
    methods: {
        setSMSBtnState(isDisable) {
            if (isDisable) {
                this.smsBtnDisable = true;
                this.smsBtnClass = "info";
            } else {
                this.smsBtnDisable = false;
                this.smsBtnClass = "primary";
            }
        },
        afterSMSSend() {
            this.isSendSMS = true;
            this.setSMSBtnState(true);
            let count = 60;
            this.smsBtnText = count.toString() + "秒后重新发送";

            let self = this;
            if (self && !self._isDestroyed) {
                self.timer = setInterval(() => {
                    if (self && !self._isDestroyed) {
                        count--;
                        if (count == 0) {
                            this.isSendSMS = false;
                            this.setSMSBtnState(false);
                            this.smsBtnText = " 发送验证码 ";
                            clearInterval(self.timer);
                        } else {
                            this.smsBtnText = count.toString() + "秒后重新发送";
                        }
                    }
                }, 1000);
            }
        },
        async smsBtnClick() {
            if (this.isSendSMS) return;
            let sendResult = await this.sendRegisterSMS();
            if (!sendResult) {
                return;
            }
        },
        async sendRegisterSMS() {
            let isSuccess = false;
            if (!this.form.Phone) {
                this.$message({
                    message: "请先输入电话号码！",
                    type: "warning"
                });
                return isSuccess;
            }
            await sendSMS(this.form.Phone, 2).then(result => {
                if (!!result) {
                    if (result.success == true) {
                        this.$message("验证码发送成功，请注意查收！");
                        isSuccess = true;
                        this.afterSMSSend();
                    } else {
                        if (result.message) {
                            this.$message({
                                message: result.message,
                                type: "error"
                            });
                        }
                    }
                }
            });
            return isSuccess;
        },
        checkAllInputs() {
            if (!this.isSendSMS) {
                if (!!this.form.Phone) {
                    this.setSMSBtnState(false);
                } else {
                    this.setSMSBtnState(true);
                }
            }

            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.submitBtnClass = "primary";
            });
        },
        async save() {
            this.errorMessage = "";
            this.showError = false;
            let valid = true;
            this.$refs.form.validate(v => {
                if (!v) {
                    valid = false;
                }
            });
            if (!valid) return;
            this.$data.form.StudentId = getStore("user_student_id");
            let result = await updatePhone(this.$data.form);
            if (result) {
                if (!result.success) {
                    this.errorMessage = result.message;
                    this.showError = true;
                } else {
                    this.showError = false;
                    this.$refs.form.resetFields();
                    this.$emit("saveSuccess", "phone");
                    this.$emit("closeEditor", "phone");
                }
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/phoneEditor.vue